import { useCallback, useState } from 'react';
import { KEIN_FEHLER, feldKorrigiert, type FehlerZustand } from './form-logik';

/** Ersetzt alert() für Validierungs- und Serverfehler (Handoff Pillen-Formulare §5):
 *  Text unverändert aus dem Code in der Fehlerleiste, betroffene Felder rot. */
export function useFormFehler() {
  const [zustand, setZustand] = useState<FehlerZustand>(KEIN_FEHLER);
  const zeige = useCallback((text: string, felder: readonly string[] = []) => setZustand({ text, felder }), []);
  const leeren = useCallback(() => setZustand(KEIN_FEHLER), []);
  /** Feld rot markieren, ohne Text (z. B. wenn der Browser ein Pflichtfeld meldet). */
  const markiere = useCallback((feld: string) => setZustand(z => (z.felder.includes(feld) ? z : { text: z.text, felder: [...z.felder, feld] })), []);
  const korrigiert = useCallback((feld: string) => setZustand(z => feldKorrigiert(z, feld)), []);
  const istFehler = useCallback((feld: string) => zustand.felder.includes(feld), [zustand.felder]);
  return { text: zustand.text, felder: zustand.felder, zeige, leeren, markiere, korrigiert, istFehler };
}
